import { insertZeros } from "./insertZeros";

export function generateThreeUniqueGrids(): number[][] {
  const NUMBERS_TO_GENERATE = 5; // Number of unique numbers in each grid
  const MIN = 1;
  const MAX = 20;
  const grids: number[][] = [];
  const uniqueGrids = new Set<string>();

  while (grids.length < 3) {
    const grid: number[] = [];
    const usedNumbers = new Set<number>();

    while (grid.length < NUMBERS_TO_GENERATE) {
      const num = Math.floor(Math.random() * (MAX - MIN + 1)) + MIN;
      if (!usedNumbers.has(num)) {
        usedNumbers.add(num);
        grid.push(num);
      }
    }

    // Sort the grid so that order does not affect uniqueness
    const sortedGrid = [...grid].sort((a, b) => a - b);
    const gridKey = sortedGrid.join(",");

    // Check if this set of numbers (regardless of order) is unique
    if (!uniqueGrids.has(gridKey)) {
      uniqueGrids.add(gridKey);
      // Transform the grid with insertZeros before storing
      const transformedGrid = insertZeros(grid);
      grids.push(transformedGrid);
    }
  }

  return grids;
}
